<template>
  <div>
    <x-grid :id="'childGrid'"
            :columns="columns"
            :toolbar-config="toolbarConfig"
            :editable="true"
            :editConfig="editConfig"
            ref="grid"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <vxe-button @click="addRow()">新增
        </vxe-button>
        <vxe-button @click="delRow(doFatherFun)">删除</vxe-button>
      </template>
    </x-grid>
  </div>
</template>

<script>
import XGrid from '@/components/grid/XGridChild'
import {GridChildMixin} from "@/utils/GridChildMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter"

const fac = XGrid.factory;
console.info(fmt);//防止不使用便利 eslint报错
//弹出层组件

//列
// const columns =


const rowIdName = 'dtlId';

//可编辑表格规则 没有特殊要求的不改
// const editRules = fac.makeEditRules(columns);

//工具栏按钮 没有可删除
const toolbarConfig = fac.makeToolbarConfig({
  templatelSlots: 'toolbarBtns'
});
//编辑配置
const editConfig = fac.makeEditConfig();

export default {
  mixins: [GridChildMixin],
  components: {},
  data() {
    let that = this;
    return {
      rowIdName,
      toolbarConfig,
      // editRules,
      columns: [
        fac.makeColumnCheckboxDefault(),
        fac.makeColumn({
          field: "projectName",
          title: "项目名称",
          width: 160,
          editRender: {
            name: 'input',
            // events: {
            //   blur(rows, e) {
            //     console.log('项目名称', rows, e)
            //     let editData = rows.data[rows.$rowIndex]
            //     editData.projectName = e.target.value
            //     if (Number(editData.count) && Number(editData.price) && Number(e.target.value)) {
            //       editData.sum = (Number(editData.count) > 0 ? Number(editData.count) : 0) * (Number(editData.price) > 0 ? Number(editData.price) : 0)
            //     }
            //   }
            // }
          },
        }),
        fac.makeColumn({
          field: "price",
          title: "单价(元)",
          width: 160,
          formatter(cellValue) {
            console.log(cellValue)
            let result = '￥' + fmt.formatMoney({cellValue: cellValue.cellValue > 0 ? cellValue.cellValue : 0}, '');
            if (cellValue.cellValue < 0) {
              that.$message.error('请输入大于0的数字');
              result = '￥' + fmt.formatMoney({cellValue: 0}, '');
            }
            return result
          },
          editRender: {
            name: 'input',
            attrs: {type: 'number'},
            events: {
              blur(rows, e) {
                let editData = rows.data[rows.$rowIndex]
                editData.price = Number(e.target.value)
                if (Number(e.target.value) && Number(editData.count)) {
                  // if (Number(e.target.value) && Number(editData.count) && Number(editData.projectName)) {
                  editData.sum = Number(e.target.value) * (Number(editData.count) > 0 ? Number(editData.count) : 0)
                }
              }
            }
          },
        }),
        fac.makeColumn({
          field: "count",
          title: "数量",
          width: 200,
          formatter(cellValue) {
            let result = fmt.formatLong({cellValue: cellValue.cellValue > 0 ? cellValue.cellValue : 0}, '');
            if (cellValue.cellValue < 0) {
              that.$message.error('请输入大于0的数字');
              result = fmt.formatLong({cellValue: 0}, '');
            }
            return result
          },
          editRender: {
            name: 'input',
            attrs: {type: 'number'},
            events: {
              blur(rows, e) {
                // console.log('数量', rows, e)
                let editData = rows.data[rows.$rowIndex]
                editData.count = Number(e.target.value)
                if (Number(e.target.value) && Number(editData.price)) {
                  // if (Number(e.target.value) && Number(editData.price) && Number(editData.projectName)) {
                  editData.sum = Number(e.target.value) * (Number(editData.price) > 0 ? Number(editData.price) : 0)
                }
              }
            }
          },
        }),
        fac.makeColumn({
          field: "sum",
          title: "费用(元)",
          width: 200,
          formatter(cellValue) {
            console.log('合计', cellValue)
            let result = '￥' + fmt.formatMoney({cellValue: cellValue.cellValue > 0 ? cellValue.cellValue : 0}, '');
            // that.setDebounce(that.doFatherFun(), 100, true);// 防抖
            that.doFatherFun();
            return result
          },
        }),
      ],
      editConfig,
    }
  },
  methods: {
    doFatherFun() {
      let that = this;
      that.$emit('changeSumCharge')
    },
    /**
     * @desc 函数防抖
     * @param func 函数
     * @param wait 延迟执行毫秒数
     * @param immediate true 表立即执行，false 表非立即执行
     */
    setDebounce(func, wait, immediate) {
      let timeout;
      return function () {
        const context = this;
        const args = [...arguments];
        if (timeout) clearTimeout(timeout);
        if (immediate) {
          const callNow = !timeout;
          timeout = setTimeout(() => {
            timeout = null;
          }, wait)
          if (callNow) func.apply(context, args)
        } else {
          timeout = setTimeout(() => {
            func.apply(context, args)
          }, wait);
        }
      }
    },

  }
}
</script>

<style scoped>
.vxe-toolbar {
  padding-left: 0
}
</style>
